const handles = {
  deletefile: ({ metadata: { ismine, size }}) => ismine ? size * -1 : 0,
  createfile: ({ metadata: { ismine, size }}) => ismine ? size : 0
}

export default function quotaUpdate(event) {
  return event.event in handles ? handles[event.event](event) : 0;
}
